<template lang="pug">
v-flex.pa-0(xs12)
  v-snackbar(:value='leadsError', color='error')
    div {{ leadsErrorMessage }}
  action-title-bar(
    :class='titlePadding',
    :title='showTitle ? title : ""',
    :is-inline='isDashboard',
    :description='isMock ? mockTotal+" Total Conversations": badgeText',
    data-cy='leads-title-bar'
  )
    qualify-preference-note(v-if = "!hidePreferences")
    template(slot='menu')
      v-menu.py-2(
        v-model='qualifyDropdown',
        offset-y,
        content-class='dropdown-box py-3',
        :close-on-content-click='false'
      )
        v-toolbar-title.liondesk(slot='activator')
          span {{ getTypeFilterName() }}
          v-icon(color='primary', right) arrow_drop_down
        v-flex.dropdown-box(xs12)
          v-flex.centered.dropdown-title.pt-2
            span.text-style QUALIFY STATUS FILTER
            v-text-field(
              v-model='searchText',
              prepend-icon='search',
              placeholder='Search by qualify status'
            )
          v-list.overflow-scroll
            v-list-tile(v-for='type in filterTypes()', @click='onTypeChange(type)')
              v-list-tile-action
                v-checkbox.light.active(
                  :input-value='selectedIDsIncludesType(type)',
                  color='primary',
                  hide-details
                )
              v-list-tile-content
                v-list-tile-title {{ type.text }}
          v-flex.centered.xs12
            v-btn(@click='onCancelTypesChanges') Cancel
            v-btn(color='primary', @click='onApplyTypesChanges') Apply
  v-flex.text-xs-left(v-if = "subtitle !== ''")
    span {{subtitle}}
  v-card
    v-container.pa-0(fluid, :class='{ "in-progress": leadsInProgress }')
      v-data-table.qualify-table(
        :headers='headersLeads',
        :style="{ height: this.isDashboard ? '424.5px' : '', 'max-height': this.isDashboard ? '424.5px' : '30vh'}"
        :items='isMock ? mockLeads : leads',
        :pagination.sync='pagination',
        hide-actions,
        :total-items='leadsTotal',
        :loading='leadsInProgress',
        loading-text='Loading... Please wait'
      )
        template(slot='items', slot-scope='props')
          tr(@click='itemGoToContact(props.item.contact_id)')
            td.text-no-wrap(data-cy='leads-qualify-fields') {{ props.item.lead_source_name }}
            td(data-cy='leads-qualify-fields')
              a(:href='itemURLContact(props.item.contact_id)', target='_blank', @click.stop) {{ props.item.contact_name }}
            td.text-no-wrap(data-cy='leads-qualify-fields') {{ props.item.status.String }}
            td.text-no-wrap(data-cy='leads-qualify-fields') {{ props.item.events }}
            td.text-no-wrap(data-cy='leads-qualify-fields') {{ dateYYMMDD(props.item.date) }}
            td.text-no-wrap(data-cy='leads-qualify-fields') {{ dateYYMMDD(props.item.last_event_date) }}
      v-layout.pagination
        v-flex.limits
          pagination-limit.mr-4(
            :limits="paginationLimits"
            :current-limit="qualifyPageSize"
            label="Recent items"
            @change:limit="loadWithNewPageLimit($event, 'qualifyPageSize')"
          )
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import ActionTitleBar from '@/Core/components/ActionTitleBar';
import { convertToYearMonthDay } from '@/Core/filters/dates';
import ShowItemTotals from '@/Core/mixins/show-item-totals';
import { headers, qualifyTypes } from '@/Core/config/qualify-leads-table';
import QualifyPreferenceNote from '@/Core/components/QualifyPreferenceNote'
import Pagination from '@/Core/mixins/pagination';
import PaginationLimit from '@/Core/components/PaginationLimit';
const { mapState: mapReportingQualifyState, mapActions: mapReportingQualifyActions } =
  createNamespacedHelpers('reportingQualify');
const { mapState: mapQualifyState, mapActions: mapQualifyActions } =
  createNamespacedHelpers('qualify');
  const { mapState: mapPreferenceState } = createNamespacedHelpers('preferences');

export default {
  name: 'QualifyLeadsList',
  mixins: [ShowItemTotals, Pagination],
  components: {
    ActionTitleBar,
    QualifyPreferenceNote,
    PaginationLimit,
  },
  created() {
    this.selectedTypesIDs = this.allTypeIDs;
    this.currentTypesIDs = this.allTypeIDs;
  },
  computed: {
    ...mapReportingQualifyState([
      'leads',
      'leadsTotal',
      'leadsInProgress',
      'leadsError',
      'leadsErrorMessage',
    ]),
    ...mapQualifyState([
      'isIntegrationConnected',
    ]),
    ...mapPreferenceState(['qualifyPageSize']),
    allTypeIDs() {
      return qualifyTypes.map(type => type.id);
    },
    badgeText() {
      const numSelected = 0; // no item selection for the widget
      return this.showItemTotals_show(
        numSelected,
        this.leadsTotal,
        'Conversation',
        'Conversations',
      );
    },
  },
  data() {
    return {
      allTypeOptionId: qualifyTypes[0].id,
      qualifyDropdown: false,
      headersLeads: headers,
      types: qualifyTypes,
      selectedTypes: JSON.parse(JSON.stringify(qualifyTypes)),
      selectedTypesIDs: [],
      currentTypesIDs: [],
      searchText: '',
      leadsQualifyPageSize: 10,
      pagination: { sortBy: 'created_at', descending: true },
      mockLeads: [],
      mockTotal: [],
    };
  },
  props: {
    isDashboard: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    titlePadding: {
      type: String,
    },
    title: {
      type: String,
    },
    hidePreferences: {
      type: Boolean,
      default: false,
    },
    subtitle: {
      type: String,
      default: '',
    },
    isMock: {
      type: Boolean,
      default: false,
    },
    leadsource: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.pagination.rowsPerPage = this.leadsQualifyPageSize;
    this.clearErrors();
    this.getLeadsQualifyData();
  },
  methods: {
    ...mapReportingQualifyActions(['getLeadsQualify', 'clearErrors']),
    dateYYMMDD(date) {
      return convertToYearMonthDay(date);
    },
    selectedTypesValues() {
      return this.selectedTypes.map(item => item.text);
    },
    async getLeadsQualifyData() {
      if (this.isMock) {
        this.mockTotal = 5;
        this.mockLeads = [
          { "contact_name": "Julian Romero", "lead_source_name": "Leads+", "status": { "String": "Qualifying", "Valid": true }, "appointment_set": false, "events": 5, "date": "2022-08-11T15:32:42.914Z", "last_event_date": "2022-09-16T19:34:20.122846Z" },
          { "contact_name": "Jeffery Alvarado", "lead_source_name": "Leads+", "status": { "String": "Follow Up Now", "Valid": true }, "events": 15, "date": "2022-08-18T15:32:42.914204Z", "last_event_date": "2022-09-06T14:52:02.404048Z" },
          { "contact_name": "Douglas Stephens", "lead_source_name": "Leads+", "status": { "String": "Follow Up Later", "Valid": true }, "events": 12, "date": "2022-08-11T15:32:42.914Z", "last_event_date": "2022-09-16T19:34:20.122846Z" },
          { "contact_name": "Jon Turner", "lead_source_name": "Leads+", "status": { "String": "Qualifying", "Valid": true }, "events": 7, "date": "2022-08-18T15:32:42.914204Z", "last_event_date": "2022-09-06T14:52:02.404048Z" },
          { "contact_name": "Myrtie Roberson", "lead_source_name": "Leads+", "status": { "String": "Qualifying", "Valid": true }, "events": 6, "date": "2022-08-11T15:32:42.914Z", "last_event_date": "2022-09-16T19:34:20.122846Z" },
          { "contact_name": "Agnes Vaughn", "lead_source_name": "Leads+", "status": { "String": "Not Interested", "Valid": true }, "events": 10, "date": "2022-08-18T15:32:42.914204Z", "last_event_date": "2022-09-06T14:52:02.404048Z" },
          { "contact_name": "Jon Turner", "lead_source_name": "Leads+", "status": { "String": "Qualifying", "Valid": true }, "events": 7, "date": "2022-08-18T15:32:42.914204Z", "last_event_date": "2022-09-06T14:52:02.404048Z" },
          { "contact_name": "Myrtie Roberson", "lead_source_name": "Leads+", "status": { "String": "Qualifying", "Valid": true }, "events": 6, "date": "2022-08-11T15:32:42.914Z", "last_event_date": "2022-09-16T19:34:20.122846Z" },
          { "contact_name": "Agnes Vaughn", "lead_source_name": "Leads+", "status": { "String": "Not Interested", "Valid": true }, "events": 10, "date": "2022-08-18T15:32:42.914204Z", "last_event_date": "2022-09-06T14:52:02.404048Z" },
        ]

      } else {
        await this.getLeadsQualify({
          selectedTypes: this.selectedTypesValues(),
          pagination: this.pagination,
          leadsource: this.leadsource,
        });
      }
    },
    filterTypes() {
      if (this.searchText.length === 0) {
        return this.types;
      }
      return this.types.filter(type =>
        type.text.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    },
    itemGoToContact(id) {
      this.$router.push(this.itemURLContact(id));
    },
    itemURLContact(id) {
      return `/contacts/${id}`;
    },
    selectedIDsIncludesType(type) {
      const selectedType = this.selectedTypesIDs.includes(type.id);
      const selectedTypeAll = this.selectedTypesIDs.includes(this.allTypeOptionId);
      return selectedType || selectedTypeAll;
    },
    onTypeChange(type) {
      if (type.id === this.allTypeOptionId) {
        if (this.selectedTypesIDs.includes(this.allTypeOptionId)) {
          this.selectedTypesIDs = [];
        } else {
          this.selectedTypesIDs = JSON.parse(JSON.stringify(this.allTypeIDs));
        }
      } else {
        if (this.selectedTypesIDs.includes(type.id)) {
          this.selectedTypesIDs.splice(this.selectedTypesIDs.indexOf(type.id), 1);
          if (this.selectedTypesIDs.includes(this.allTypeOptionId)) {
            this.selectedTypesIDs.splice(this.selectedTypesIDs.indexOf(this.allTypeOptionId), 1);
          }
        } else {
          this.selectedTypesIDs.push(type.id);
          const isAllOptions = this.selectedTypesIDs.length === this.types.length - 1;
          if (isAllOptions) {
            this.selectedTypesIDs = JSON.parse(JSON.stringify(this.allTypeIDs));
          }
        }
      }
    },
    getTypeFilterName() {
      const isAllOption = this.currentTypesIDs.includes(this.allTypeOptionId);
      const isAllOptions = this.currentTypesIDs.length === this.types.length - 1;
      if (isAllOption || isAllOptions) {
        return this.types[0].text;
      }
      return `Filters Selected (${this.currentTypesIDs.length}/${this.types.length - 1})`;
    },

    onApplyTypesChanges() {
      if (this.selectedTypesIDs.length === 0) {
        this.selectedTypesIDs = JSON.parse(JSON.stringify(this.allTypeIDs));
      }

      this.currentTypesIDs = JSON.parse(JSON.stringify(this.selectedTypesIDs));
      this.selectedTypes = this.types.filter(type => this.currentTypesIDs.includes(type.id));
      this.getLeadsQualifyData();
      this.qualifyDropdown = false;
      this.searchText = '';
    },
    onCancelTypesChanges() {
      this.selectedTypesIDs = JSON.parse(JSON.stringify(this.currentTypesIDs));
      this.qualifyDropdown = false;
      this.searchText = '';
    },
  },
  watch: {
    qualifyPageSize(value) {
      this.pagination.rowsPerPage = value;
      this.getLeadsQualify({
          selectedTypes: this.selectedTypesValues(),
          pagination: this.pagination,
          leadsource: this.leadsource,
        });
    },
    'pagination.sortBy'(value) {
      this.getLeadsQualifyData();
    },
    'pagination.descending'(value) {
      this.getLeadsQualifyData();
    },
    isMock(value) {
      this.getLeadsQualifyData();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../Core/assets/scss/main.scss';
.flex.centered.dropdown-title {
  background: #fff;
}
.options {
  color: #20779c;
  font-size: 12px;
}
.actions {
  align-self: center;
}
.centered {
  display: flex;
  justify-content: center;
}
.dropdown-title {
  flex-direction: column;
  padding-left: 16px;
  padding-right: 16px;
}
.icon {
  font-size: 18px;
  border-radius: 50%;
  color: var(--v-background-lighten5) !important;
  height: 35px;
  width: 35px;
}
.menu {
  color: #20779c;
  font-size: 14px;
  font-weight: bold;
}
.qualify-table /deep/ .v-table__overflow {
  overflow-y: auto;
  overflow-x: auto;
  height: 100% !important;
  tbody {
    tr:hover {
      box-shadow: none;
      cursor: pointer;
    }
  }
  thead {
    tr {
      height: auto;
    }
    th {
      padding: 14px;
      position: -webkit-sticky;
      position: sticky;
      background-color: #fff;
      top: 0;
      z-index: 1;
    }
    th:first-child {
      z-index: 2;
    }
  }
  table {
    position: -webkit-sticky;
    position: sticky;
  }
}
</style>

<style lang="scss" scoped>
.custom-inputs .v-text-field .v-input__control .v-input__slot {
  min-height: auto;
  display: flex;
  align-items: center;
}

.custom-inputs .theme--light .v-label,
.custom-inputs .theme--light .v-icon {
  color: #20779c;
}
.theme--light.v-footer {
  background: #fff;
}
.overflow-scroll {
  height: 300px;
  width: 300px;
  overflow-y: auto;
  overflow-x: auto;
}

.text-style {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
}

.dropdown-box {
  background-color: white;
}

.more--menu.v-menu.v-menu--inline {
  .v-menu__activator {
    height: 35px !important;
  }
}
</style>
